<div class="toast-container" *ngIf="show">
	<div class="alert alert-success alert-dismissible fade show" role="alert" *ngFor="let toast of toasts">
		<strong> {{toast.title}} </strong> {{toast.message}}
		<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
	</div>
</div>
